import * as React from "react";

import type { ModuleTracking, TrackingAttributes } from "~types/lineup";
import type { CuratedItem } from "~types/types";
import { integrityError } from "~utils/moduleIntegrity";
import trackStoriesInModules from "~utils/trackStoriesInModules";

import integrityCheck from "./ItemWithTracking.integrity";

export interface ItemWithTrackingProps {
    containerTag: "article" | "div";
    item: CuratedItem;
    className: string;
    componentName?: string;
    moduleTracking?: ModuleTracking;
    storyCount?: number;
}

interface ArticleAttributes {
    "data-id"?: string;
    "data-type"?: string;
    "data-component"?: string;
}

export default function Article(
    props: React.PropsWithChildren<ItemWithTrackingProps>
) {
    const integrity = integrityCheck(props);

    if (integrity.length) return integrityError(integrity);

    const {
        containerTag: ContainerTag,
        item,
        componentName,
        storyCount,
        moduleTracking,
        className,
        children,
    } = props;

    const trackingAttributes: TrackingAttributes = trackStoriesInModules({
        storyId: item.id,
        storyCount,
        trackingType: item.trackingType,
        moduleTracking,
    });

    const articleAttributes: ArticleAttributes = {};

    if (componentName) articleAttributes["data-component"] = componentName;
    if ("id" in item) articleAttributes["data-id"] = item.id;
    if ("type" in item) articleAttributes["data-type"] = item.type!;

    return (
        <ContainerTag
            className={className}
            {...articleAttributes}
            {...trackingAttributes}
        >
            {children}
        </ContainerTag>
    );
}
